var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadAssetIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1673 27.1667L20.5007 20.5L13.834 27.1667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 20.5V35.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4838 31.1498C36.1093 30.2636 37.3935 28.8613 38.1335 27.1642C38.8736 25.4671 39.0274 23.5719 38.5708 21.7776C38.1141 19.9834 37.0729 18.3923 35.6115 17.2556C34.1502 16.1188 32.3519 15.501 30.5004 15.4998H28.4004C27.8959 13.5485 26.9557 11.737 25.6503 10.2015C24.345 8.6659 22.7085 7.44623 20.8639 6.63416C19.0193 5.82208 17.0147 5.43874 15.0006 5.51295C12.9866 5.58715 11.0155 6.11698 9.23572 7.06259C7.4559 8.0082 5.91361 9.34498 4.72479 10.9724C3.53598 12.5999 2.73157 14.4757 2.37206 16.4588C2.01254 18.4419 2.10726 20.4807 2.64911 22.4219C3.19096 24.3631 4.16583 26.1563 5.50042 27.6665",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadAssetIcon);
export default __webpack_public_path__ + "static/media/upload-asset-icon.3239d21c6b9225bf3c20e1bca7913caf.svg";
export { ForwardRef as ReactComponent };